import { render, staticRenderFns } from "./SetPassword.vue?vue&type=template&id=71fa8e91&scoped=true"
import script from "./SetPassword.vue?vue&type=script&lang=js"
export * from "./SetPassword.vue?vue&type=script&lang=js"
import style0 from "./SetPassword.vue?vue&type=style&index=0&id=71fa8e91&prod&lang=scss&scoped=true"
import style1 from "./SetPassword.vue?vue&type=style&index=1&id=71fa8e91&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fa8e91",
  null
  
)

export default component.exports